'use strict';

/**
 * Setup Global Esensi namespace
 */

var Esensi = window.Esensi = window.Esensi || {};
module.exports = Esensi;
